import React, { useState, useEffect, useRef } from 'react'
import NavBarTop from '../Reusable_Components/NavBarTop'
import LeftNavBar from '../Reusable_Components/LeftNavBar'
import FormLoader from '../Reusable_Components/FromLoader'
import { useDispatch, useSelector } from 'react-redux'
import { GET_PARTNER_COMPANY_DETAILS_FAILURE, GET_PARTNER_COMPANY_DETAILS_SUCCESS, SET_LOADER, UPDATE_PARTNER_COMPANY_DETAILS_FAILURE, UPDATE_PARTNER_COMPANY_DETAILS_SUCCESS, UPLOAD_DSC_FAILURE, UPLOAD_LOGO_FAILURE, getPartnerCompanyDetails, updatePartnerCompanyDetails, uploadDscFile, uploadLogo } from '../../Redux/Actions/Actions'
import { Button, Modal } from 'react-bootstrap'
import { MdErrorOutline } from 'react-icons/md'
import { FaSearch } from 'react-icons/fa'
import UploadComponent from '../Reusable_Components/UploadComponent'
import axios from 'axios'
import { base_url } from '../../utilities'
import { validEmailCheck, processAndValidateEmail, encrypt } from "../Reusable_Components/ReusableFunctions";
import { RiLockPasswordLine } from 'react-icons/ri'


export default function PartnerCompaniesEdit(props) {

    const [emailError, setEmailError] = useState('');

    const childRef = useRef(null)

    const dispatch = useDispatch()

    const id = props?.companyId

    const partnerCompanyDetails = useSelector(state => state.partnerCompanyDetails)
    const partnerCompanyDetailsError = useSelector(state => state.partnerCompanyDetailsError)
    const loading = useSelector(state => state.loading)
    const updatePartnerCompanyDetailsSuccess = useSelector(state => state.updatePartnerCompanyDetailsSuccess)
    const updatePartnerCompanyDetailsError = useSelector(state => state.updatePartnerCompanyDetailsError)
    const uploadLogoError = useSelector(state => state.uploadLogoError)
    const uploadDscError = useSelector(state => state.uploadDscError)

    const [filesData, setFilesData] = useState([])
    const [dscFilesData, setDscFilesData] = useState([])
    const [signerNameError, setSignerNameError] = useState(null)

    const [showOtpModal, setShowOtpModal] = useState(false)
    const [otp, setOTP] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef(otp.map(() => React.createRef())); // Create refs for each input field
    const [dscFiles, setDscFiles] = useState([])
    const [isValidOTP, setIsValidOTP] = useState(null)
    const [fileIndex, setFileIndex] = useState(null)
    const [showDscPasswordModal, setShowDscPasswordModal] = useState(false)
    const [dscPassword, setDscPassword] = useState('')

    const [edit, setEdit] = useState(false)

    const [gstLoader, setGstLoader] = useState(false);
    const [gstDetailsChanged, setGstDetailsChanged] = useState(false);
    const [savedSnapshot, setSavedSnapshot] = useState(null);
    const [gstSuccessMsg, setGstSuccessMsg] = useState(null);
    const [gstErrorMsg, setGstErrorMsg] = useState(null);

    useEffect(() => {
        dispatch(getPartnerCompanyDetails(id))
    }, [])

    useEffect(() => {
        if (partnerCompanyDetails?.partner_company_id) {
            setSavedSnapshot(partnerCompanyDetails);
            setGstDetailsChanged(false);
        }
    }, [partnerCompanyDetails?.partner_company_id])

    useEffect(() => {
        if (updatePartnerCompanyDetailsSuccess && partnerCompanyDetails?.partner_company_id) {
            setSavedSnapshot(partnerCompanyDetails);
            setGstDetailsChanged(false);
        }
    }, [updatePartnerCompanyDetailsSuccess])

    useEffect(() => {
        if (!edit) setGstDetailsChanged(false);
    }, [edit])

    const GstLoader = () => (
        <div className="spinner-border spinner-border-sm text-light" role="status" style={{ width: 20, height: 20 }}>
            <span className="visually-hidden">Loading...</span>
        </div>
    );

    const handleGstClick = (gstId) => {
        if (!gstId) return;
        setGstLoader(true);
        axios.get(`${base_url}gstPortal/verifyGstin?gst_number=${gstId}`)
            .then((response) => {
                if (response?.data?.data?.[0] === 'error') {
                    setGstErrorMsg(response?.data?.data?.[1]?.message || 'Failed to fetch GST details.');
                    setGstLoader(false);
                    return;
                }
                const details = response?.data?.data;
                const newAddress = {
                    ...(partnerCompanyDetails?.registered_address || {}),
                    door_number: details?.registered_address?.door_number,
                    street_address_1: details?.registered_address?.street_address_1,
                    street_address_2: details?.registered_address?.street_address_2,
                    city: details?.registered_address?.city,
                    state: details?.registered_address?.state,
                    postal_code: details?.registered_address?.postal_code,
                    country: details?.registered_address?.country ?? partnerCompanyDetails?.registered_address?.country,
                };
                dispatch({
                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                    payload: { ...partnerCompanyDetails, registered_address: newAddress }
                });
                const saved = savedSnapshot?.registered_address;
                const changed = !!saved && (
                    newAddress.door_number !== saved.door_number ||
                    newAddress.street_address_1 !== saved.street_address_1 ||
                    newAddress.street_address_2 !== saved.street_address_2 ||
                    newAddress.city !== saved.city ||
                    newAddress.state !== saved.state ||
                    (newAddress.postal_code?.toString() ?? '') !== (saved.postal_code?.toString() ?? '')
                );
                setGstDetailsChanged(changed);
                setGstLoader(false);
            })
            .catch((error) => {
                let message = 'Failed to fetch GST details.';
                try {
                    const errorDetails = JSON.parse(error?.response?.data?.error_logs?.status_desc);
                    message = errorDetails?.[0]?.ErrorMessage || error?.response?.data?.message || message;
                } catch (_) {
                    message = error?.response?.data?.message || message;
                }
                setGstErrorMsg(message);
                setGstLoader(false);
            });
    }

    const handleUpdateGstAddress = () => {
        if (!gstDetailsChanged || !savedSnapshot) return;
        const freshAddress = partnerCompanyDetails?.registered_address || {};
        const postal_code = freshAddress?.postal_code;
        const payload = {
            ...savedSnapshot,
            registered_address: {
                ...freshAddress,
                postal_code: postal_code != null ? postal_code.toString() : postal_code,
            }
        };
        dispatch({ type: SET_LOADER, payload: true });
        axios.put(`${base_url}customers/partnerCompanies`, payload)
            .then((res) => {
                if (res.status === 200) {
                    setSavedSnapshot({ ...savedSnapshot, registered_address: payload.registered_address });
                    setGstDetailsChanged(false);
                    setGstSuccessMsg("- GST address has been updated successfully");
                }
                dispatch({ type: SET_LOADER, payload: false });
            })
            .catch((err) => {
                setGstErrorMsg(err?.response?.data?.message || 'Failed to update GST address.');
                dispatch({ type: SET_LOADER, payload: false });
            });
    }

    const handleFileUpload = async (index) => {
        const data = {
            "files": [
                {
                    "file_content": filesData[index]["file_obj"],
                    "object_type": "our_company_logo",
                    "file_type": filesData[index]["file_type"].split("/")[1],
                    "file_name": filesData[index]["file_name"],
                    "flag": null,
                    "file_description": "",
                    "company_name": partnerCompanyDetails?.company_name,
                    "user_id": localStorage.getItem("username"),
                }
            ]
        }
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios
            .post(base_url + "documents", data)
            .then((response) => {
                dispatch({
                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                    payload: { ...partnerCompanyDetails, logo: response?.data?.data[0].key }
                })
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            }
            )
            .catch((error) => {
                dispatch({
                    type: UPLOAD_LOGO_FAILURE,
                    payload: error.response.data.message,
                });
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            });
    }

    const handleEmailChange = (e) => {
        const input = e.target.value;
        const { processedInput, isValid } = processAndValidateEmail(input, partnerCompanyDetails.email);
        if (processedInput === '') {
            setEmailError('Email is required');
        } else if (!isValid) {
            setEmailError('Enter a valid email address');
        } else {
            setEmailError('');
        }
        dispatch({
            type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
            payload: { ...partnerCompanyDetails, email: processedInput }
        });
    };

    const updatePartnerDetails = () => {
        const updatedPartnerCompanyDetails = {
            ...partnerCompanyDetails,
            email: partnerCompanyDetails.email.trim(),
            short_name: partnerCompanyDetails.short_name.trim(),
            signer_name: partnerCompanyDetails.signer_name.trim()
        };
        dispatch(updatePartnerCompanyDetails(updatedPartnerCompanyDetails));
    }

    const handleSelectFile = (files) => {
        dispatch({
            type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
            payload: { ...partnerCompanyDetails, logo: null }
        })
        const processedFiles1 = [];
        files.forEach((file) => {
            const reader1 = new FileReader();
            reader1.onloadend = function () {
                const base64FileContent = reader1.result.split(",")[1];
                const processedFile1 = {
                    file_obj: base64FileContent,
                    file_name: file.file.name,
                    file_type: file.file.type,
                };
                processedFiles1.push(processedFile1);
                if (processedFiles1.length === files.length) {
                    setFilesData(processedFiles1);
                }
            };
            reader1.readAsDataURL(file.file);
        });
    }

    const selectDscFile = (files) => {
        dispatch({
            type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
            payload: { ...partnerCompanyDetails, dsc: null }
        })
        const processedFiles1 = [];
        files.forEach((file) => {
            const reader1 = new FileReader();
            reader1.onloadend = function () {
                const base64FileContent = reader1.result.split(",")[1];
                const processedFile1 = {
                    file_obj: base64FileContent,
                    file_name: file.file.name,
                    file_type: file.file.type,
                };
                processedFiles1.push(processedFile1);
                if (processedFiles1.length === files.length) {
                    setDscFilesData(processedFiles1);
                }
            };
            reader1.readAsDataURL(file.file);
        });
    }

    const uploadDscPassowrd = () => {
        let data = {
            gst_number: partnerCompanyDetails?.gst_number,
            dsc_password: dscPassword,
        }
        axios.put(`${base_url}customers/dscPassword`, data)
            .then((res) => {
                // console.log(res)
            })
            .catch(err => {
                console.log(err)
                dispatch({
                    type: UPLOAD_LOGO_FAILURE,
                    payload: err.response.data.message
                })
            })
    }

    const uploadDsc = (index) => {
        const data = {
            "files": [
                {
                    "file_content": dscFilesData[index]["file_obj"],
                    "object_type": "our_company_dsc",
                    "file_type": "pfx",
                    "file_name": dscFilesData[index]["file_name"],
                    "flag": null,
                    "file_description": "",
                    "company_name": partnerCompanyDetails?.company_name,
                    "user_id": localStorage.getItem("username"),
                }
            ]
        }
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios
            .post(base_url + "documents", data)
            .then((response) => {
                callChildFunction()
                dispatch({
                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                    payload: { ...partnerCompanyDetails, dsc: response?.data?.data[0].key }
                })
                uploadDscPassowrd()
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            }
            )
            .catch((error) => {
                dispatch({
                    type: UPLOAD_DSC_FAILURE,
                    payload: error.response.data.message,
                });
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            });
    }

    const handleChange = (index, event) => {
        const value = event.target.value;
        if (isNaN(value)) return; // Only allow numeric input

        const newOTP = [...otp];
        newOTP[index] = value;
        setOTP(newOTP);

        if (value !== '' && index < inputRefs.current.length - 1) {
            inputRefs?.current[index + 1]?.current?.focus(); // Move focus to the next input field
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace') {
            const newOTP = [...otp];
            if (otp[index] === "") {
                if (index > 0) {
                    inputRefs.current[index - 1].current.focus(); // Move focus to the previous input field if backspace is pressed
                }
            } else {
                newOTP[index] = "";
                setOTP(newOTP);
            }
        } else if ((event.key === 'Enter' && index === otp.length - 1) || (event.key === 'Enter' && otp.join('').length === 6)) {
            // handleVerifyOTP()
        }
    };

    const handlePaste = event => {
        event.preventDefault();
        const paste = event.clipboardData.getData('text/plain');
        if (/^\d+$/.test(paste) && paste.length <= 6) {
            const newOTP = [...otp];
            for (let i = 0; i < paste.length; i++) {
                if (i < newOTP.length) {
                    newOTP[i] = paste[i];
                }
            }
            setOTP(newOTP);
        }
    };

    const sendOtp = (files) => {
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios.post(`${base_url}authorization/setMFAOTP`, encrypt({
            username: localStorage.getItem("username")
        }))
            .then((res) => {
                setDscFiles(files)
                files && files.length > 0 && setShowOtpModal(true)
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
            .catch(err => {
                console.log(err)
                callChildFunction()
                dispatch({
                    type: UPLOAD_LOGO_FAILURE,
                    payload: err.response.data.message
                })
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
    }

    const handleVerifyDscOtp = () => {
        selectDscFile(dscFiles)
        dispatch({
            type: SET_LOADER,
            payload: true
        })
        axios.post(`${base_url}authorization/validateMFAOTP`, encrypt({ "username": localStorage.getItem("username"), "otp": otp.join('') }))
            .then((res) => {
                if (res.data.data?.actual_status === "error") {
                    setIsValidOTP(res.data.data?.message)
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                    return
                }
                else {
                    setOTP(['', '', '', '', '', ''])
                    setShowOtpModal(false)
                    dispatch({
                        type: SET_LOADER,
                        payload: false
                    })
                }
            })
            .catch(err => {
                console.log(err)
                setIsValidOTP(err.response.data.message)
                setOTP(['', '', '', '', '', ''])
                dispatch({
                    type: SET_LOADER,
                    payload: false
                })
            })
        // setShowOtpModal(false)
    }

    const handlePasswordModal = (index) => {
        setShowDscPasswordModal(true)
        setFileIndex(index)
        // uploadDsc(index)
    }

    const callChildFunction = () => {
        if (childRef.current) {
            childRef.current.childFunction();
        }
    }

    return (
        <>
            <div className="addUserContainer our-companies-form-container">
                {loading && <FormLoader />}
                <div className="stepsContainer">
                    <div className="stepsTitle">
                        <h6 style={{ padding: "20px", lineHeight: "0px" }}>Edit Partner Company Details</h6>
                    </div>
                    <div className={'stepsCardActive'}>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <span style={{ fontWeight: "bold", fontSize: "medium" }}>Company Information</span>
                        </div>
                        <span style={{ fontSize: "small", marginTop: "10px" }}>Partner Company Details</span>
                    </div>
                </div>
                <div className="infoContainer">
                    <div className="our-companies-info-content">
                        <div className="infoTitle">
                            <h6 style={{ padding: "20px", lineHeight: "0px" }}>Company Information</h6>
                        </div>
                        <div className="infoBody">
                            <div className="infoForm">
                                <div>
                                    <h4>{partnerCompanyDetails?.company_name}</h4>
                                </div>
                                <div className="inputsSection">
                                    <div>
                                        <label className='add-facility-modal-label'>GST Number  <span style={{ color: "red" }}>*</span></label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <input type='text' disabled={true} value={partnerCompanyDetails?.gst_number} className='form-control responsive-add-facility-input-fields' />
                                            {edit && (
                                                <div
                                                    style={{
                                                        background: "grey",
                                                        padding: "9px 10px",
                                                        borderRadius: "5px",
                                                        opacity: !partnerCompanyDetails?.gst_number ? 0.3 : 1,
                                                        pointerEvents: !partnerCompanyDetails?.gst_number ? 'none' : 'auto',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                    className="C-pointer"
                                                    onClick={() => {
                                                        if (partnerCompanyDetails?.gst_number) {
                                                            handleGstClick(partnerCompanyDetails?.gst_number);
                                                        }
                                                    }}
                                                >
                                                    {gstLoader ? <GstLoader /> : <FaSearch color="white" size={20} style={{ fontWeight: "bolder" }} />}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <label className='add-facility-modal-label'>CIN  <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled={true} value={partnerCompanyDetails?.cin} className='form-control responsive-add-facility-input-fields' />
                                    </div>
                                </div>
                                {gstDetailsChanged && edit && (
                                    <div className="d-flex align-items-center gap-2 justify-content-between warning-message" style={{ marginTop: "10px" }}>
                                        <p style={{ marginBottom: "0px", color: "orangered" }}>The GST address has been changed but not updated. Please click the update button to update the GST address.</p>
                                        <button onClick={handleUpdateGstAddress} style={{ height: "30px", padding: "0 12px" }} className="btn btn-secondary">Update</button>
                                    </div>
                                )}
                                <div className="inputsSection">
                                    <div>
                                        <label className='add-facility-modal-label'>Short Name  <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled={!edit} value={partnerCompanyDetails?.short_name} className='form-control responsive-add-facility-input-fields'
                                            onChange={(e) => {
                                                let value = e.target.value;
                                            // Restrict if only numbers, allow if contains any character
                                            if (/^[0-9]+$/.test(value)) {
                                                return;
                                            }
                                            value = value?.toUpperCase();
                                            dispatch({
                                                type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                                                payload: { ...partnerCompanyDetails, short_name: value }
                                            });
                                        }}
                                        />
                                    </div>
                                    <div>
                                        <label className='add-facility-modal-label'>Email ID  <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled={!edit} value={partnerCompanyDetails?.email} className='form-control responsive-add-facility-input-fields'
                                            onChange={handleEmailChange}
                                        />
                                        <span className='text-danger'>{emailError}</span>
                                    </div>
                                </div>
                                <hr></hr>
                                <b className='d-flex my-4'>Gst Primary Address</b>
                                <div className="inputsSection">
                                    <div>
                                        <label className='add-facility-modal-label'>Door Number <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled value={partnerCompanyDetails?.registered_address?.door_number}
                                            onChange={(e) => {
                                                let registered_address = { ...partnerCompanyDetails?.registered_address, door_number: e.target.value }
                                                dispatch({
                                                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                                                    payload: { ...partnerCompanyDetails, registered_address: registered_address }
                                                })
                                            }}
                                            className='form-control responsive-add-facility-input-fields' />
                                    </div>
                                    <div>
                                        <label className='add-facility-modal-label'>Street Address <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled value={partnerCompanyDetails?.registered_address?.street_address_1}
                                            onChange={(e) => {
                                                let registered_address = { ...partnerCompanyDetails?.registered_address, street_address_1: e.target.value }
                                                dispatch({
                                                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                                                    payload: { ...partnerCompanyDetails, registered_address: registered_address }
                                                })
                                            }}
                                            className='form-control responsive-add-facility-input-fields' />
                                    </div>
                                    <div >
                                        <label className='add-facility-modal-label'>Street Address Lane 2 <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled value={partnerCompanyDetails?.registered_address?.street_address_2}
                                            onChange={(e) => {
                                                let registered_address = { ...partnerCompanyDetails?.registered_address, street_address_2: e.target.value }
                                                dispatch({
                                                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                                                    payload: { ...partnerCompanyDetails, registered_address: registered_address }
                                                })
                                            }}
                                            className='form-control responsive-add-facility-input-fields' />
                                    </div>
                                </div>
                                <div className="inputsSection">
                                    <div>
                                        <label className='add-facility-modal-label'>City <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled value={partnerCompanyDetails?.registered_address?.city}
                                            onChange={(e) => {
                                                let registered_address = { ...partnerCompanyDetails?.registered_address, city: e.target.value }
                                                dispatch({
                                                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                                                    payload: { ...partnerCompanyDetails, registered_address: registered_address }
                                                })
                                            }}
                                            className='form-control responsive-add-facility-input-fields' />
                                    </div>
                                    <div>
                                        <label className='add-facility-modal-label'>State <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled value={partnerCompanyDetails?.registered_address?.state}
                                            onChange={(e) => {
                                                let registered_address = { ...partnerCompanyDetails?.registered_address, state: e.target.value }
                                                dispatch({
                                                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                                                    payload: { ...partnerCompanyDetails, registered_address: registered_address }
                                                })
                                            }}
                                            className='form-control responsive-add-facility-input-fields' />
                                    </div>
                                    <div >
                                        <label className='add-facility-modal-label'>Pincode <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled value={partnerCompanyDetails?.registered_address?.postal_code}
                                            onChange={(e) => {
                                                let registered_address = { ...partnerCompanyDetails?.registered_address, postal_code: e.target.value }
                                                dispatch({
                                                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                                                    payload: { ...partnerCompanyDetails, registered_address: registered_address }
                                                })
                                            }}
                                            className='form-control responsive-add-facility-input-fields' />
                                    </div>
                                </div>
                                <div className='inputsSection'>
                                    <div className='w-100'>
                                        <label className='add-facility-modal-label'>Upload logo </label>
                                        <UploadComponent
                                            onFilesSelected={handleSelectFile}
                                            viewMode={!edit}
                                            uploadedFileData={partnerCompanyDetails?.logo ? [{ file_name: partnerCompanyDetails?.logo?.split("/")[2]?.split("-")[0], file_type: partnerCompanyDetails?.logo?.split("/")[2]?.split(".")[1], s3_key: partnerCompanyDetails?.logo }] : []}
                                            deleteSpecificFileMain={0}
                                            uploadActionClicked={handleFileUpload}
                                            idType={"our_company_edit"}
                                            acceptedFileTypes={".jpeg, .jpg, .png"}
                                        />
                                    </div>
                                </div>
                                <hr></hr>
                                <b className='d-flex my-4'>DSC Details</b>
                                <div className="inputsSection">
                                    <div>
                                        <label className='add-facility-modal-label'>Signer's Name <span style={{ color: "red" }}>*</span></label>
                                        <input type='text' disabled={!edit} value={partnerCompanyDetails?.signer_name} className='form-control responsive-add-facility-input-fields' onChange={(e) => {
                                            let value = e.target.value
                                            if (value.length < 3 || value.length > 200) {
                                                setSignerNameError("Must be between 3 to 200 characters")
                                                dispatch({
                                                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                                                    payload: { ...partnerCompanyDetails, signer_name: value }
                                                })
                                            } else {
                                                setSignerNameError(null)
                                                dispatch({
                                                    type: GET_PARTNER_COMPANY_DETAILS_SUCCESS,
                                                    payload: { ...partnerCompanyDetails, signer_name: value }
                                                })
                                            }
                                        }} />
                                        <span className='text-danger'>{signerNameError}</span>
                                    </div>
                                </div>
                                <div className="inputsSection">
                                    <div className='w-100'>
                                        <label className='add-facility-modal-label'>Upload DSC (pfx file) <span style={{ color: "red" }}>*</span></label>
                                        <UploadComponent
                                            onFilesSelected={(files) => {
                                                // Only send OTP if a new file is selected (not just description change)
                                                if (
                                                    files &&
                                                    files.length > 0 &&
                                                    (
                                                        dscFiles.length === 0 ||
                                                        files[0].file.name !== dscFiles[0]?.file?.name
                                                    )
                                                ) {
                                                    sendOtp(files);
                                                }
                                                // Always update dscFiles so description changes still work
                                                setDscFiles(files);
                                            }}
                                            uploadActionClicked={handlePasswordModal}
                                            viewMode={!edit}
                                            deleteSpecificFileMain={0}
                                            uploadedFileData={partnerCompanyDetails?.dsc && partnerCompanyDetails?.dsc ? [{ file_name: partnerCompanyDetails?.dsc?.split("/")[2]?.split("-")[0], file_type: partnerCompanyDetails?.dsc?.split("/")[2]?.split(".")[1], s3_key: partnerCompanyDetails?.dsc }] : []}
                                            idType={"our_company_dsc"}
                                            acceptedFileTypes={".pfx"}
                                            ref={childRef}
                                            dscUpload={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="infoFotter">
                        <div className="button-group d-flex justify-content-end gap-3">
                            <button className="btn btn-primary secondary-button" onClick={() => props.setPage(1)}>Back</button>
                            {edit && <button className="btn btn-primary secondary-button" onClick={() => setEdit(false)}>Cancel</button>}
                            {edit ? <button className="btn btn-primary primary-button" disabled={emailError
                                || !(partnerCompanyDetails.short_name) || !(partnerCompanyDetails.registered_address?.door_number) ||
                                !(partnerCompanyDetails.registered_address?.street_address_1) || !(partnerCompanyDetails.registered_address?.street_address_2) ||
                                !(partnerCompanyDetails.registered_address?.city) || !(partnerCompanyDetails.registered_address?.state) || !(partnerCompanyDetails.registered_address?.postal_code)
                                || !(partnerCompanyDetails.signer_name || signerNameError)
                            } onClick={updatePartnerDetails}>Update</button> : <button className="btn btn-primary primary-button" onClick={() => setEdit(true)}>Edit</button>}
                        </div>
                    </div>
                </div>
                {updatePartnerCompanyDetailsSuccess && <Modal keyboard={false} backdrop="static" show={updatePartnerCompanyDetailsSuccess} onHide={() => {
                    dispatch({
                        type: UPDATE_PARTNER_COMPANY_DETAILS_SUCCESS,
                        payload: null
                    })
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <img src="./images/icons/popper.svg" alt="Party Popper" />
                        <h5>Success!</h5>
                        <p className="mb-3"><b>{partnerCompanyDetails?.company_name}</b> {updatePartnerCompanyDetailsSuccess}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            dispatch({
                                type: UPDATE_PARTNER_COMPANY_DETAILS_SUCCESS,
                                payload: null
                            })
                            props?.setNavigate(!props?.navigat)
                            props?.setPage(1)
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {updatePartnerCompanyDetailsError && <Modal keyboard={false} backdrop="static" show={updatePartnerCompanyDetailsError} onHide={() => {
                    dispatch({
                        type: UPDATE_PARTNER_COMPANY_DETAILS_FAILURE,
                        payload: null
                    })
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <MdErrorOutline color='red' style={{ height: "60px", width: "60px", fontWeight: "10px" }} />
                        <h5>Error!</h5>
                        <p className="mb-3">{updatePartnerCompanyDetailsError}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            dispatch({
                                type: UPDATE_PARTNER_COMPANY_DETAILS_FAILURE,
                                payload: null
                            })
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {partnerCompanyDetailsError && <Modal keyboard={false} backdrop="static" show={partnerCompanyDetailsError} onHide={() => {
                    dispatch({
                        type: GET_PARTNER_COMPANY_DETAILS_FAILURE,
                        payload: null
                    })
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <MdErrorOutline color='red' style={{ height: "60px", width: "60px", fontWeight: "10px" }} />
                        <h5>Error!</h5>
                        <p className="mb-3">{partnerCompanyDetailsError}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            dispatch({
                                type: GET_PARTNER_COMPANY_DETAILS_FAILURE,
                                payload: null
                            })
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {uploadLogoError && <Modal keyboard={false} backdrop="static" show={uploadLogoError} onHide={() => {
                    dispatch({
                        type: UPLOAD_LOGO_FAILURE,
                        payload: null
                    })
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <MdErrorOutline color='red' style={{ height: "60px", width: "60px", fontWeight: "10px" }} />
                        <h5>Error!</h5>
                        <p className="mb-3">{uploadLogoError}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            dispatch({
                                type: UPLOAD_LOGO_FAILURE,
                                payload: null
                            })
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {showOtpModal && <Modal keyboard={false} backdrop="static" show={showOtpModal} centered >
                    <Modal.Header>
                        <Modal.Title><div>
                            Enter OTP
                            <div style={{ fontSize: "14px", color: "gray" }}>OTP has been sent to your mail</div>
                        </div></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column justify-content-center align-items-center gap-3 w-60">
                        <span className="text-danger" style={{ textAlign: "left", width: "80%", fontSize: "12px" }}>
                            {isValidOTP && isValidOTP?.length > 0 && isValidOTP}
                        </span>
                        <div className="d-flex gap-2">
                            {otp.map((digit, index) => (
                                <input
                                    style={{ width: "50px", height: "50px", fontSize: "20px", textAlign: "center", borderRadius: "5px", border: "1px solid gray" }}
                                    key={index}
                                    type="text"
                                    maxLength="1"
                                    value={digit}
                                    onChange={e => {
                                        // console.log(e)
                                        handleChange(index, e)
                                    }}
                                    onKeyDown={e => {
                                        handleKeyDown(index, e)
                                    }}
                                    onFocus={(e) => {
                                        e.target.select()
                                        // setIsValidOTP(null)
                                    }}
                                    onPaste={handlePaste}
                                    ref={inputRefs.current[index]}
                                />
                            ))}
                        </div>
                        {/* {timerActive && <div>Resend OTP in : {formatTime(timeLeft)}</div>}
                                            {!timerActive && <span className="">Send another OTP? {timeLeft <= 0 ? <Link className="C-pointer" onClick={handleSendOtp}>Resend</Link> : <span title={`Resend in ${timeLeft}`} className="C-pointer" style={{ color: "gray" }}>Resend</span>}</span>} */}
                    </Modal.Body>
                    <Modal.Footer className="footer">
                        <Button variant="secondary" className="secondary-left" onClick={() => {
                            setOTP(['', '', '', '', '', ''])
                            setShowOtpModal(false)
                            callChildFunction()
                            // setIsValidOTP('')
                        }}>Close</Button>
                        <Button variant="secondary" className="secondary" onClick={handleVerifyDscOtp}>Verify</Button>
                    </Modal.Footer>
                </Modal>}
                {gstSuccessMsg && <Modal keyboard={false} backdrop="static" show={!!gstSuccessMsg} onHide={() => setGstSuccessMsg(null)} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <img src="./images/icons/popper.svg" alt="Party Popper" />
                        <h5>Success!</h5>
                        <p className="mb-3"><b>{partnerCompanyDetails?.company_name}</b> {gstSuccessMsg}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => setGstSuccessMsg(null)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {gstErrorMsg && <Modal keyboard={false} backdrop="static" show={!!gstErrorMsg} onHide={() => setGstErrorMsg(null)} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <MdErrorOutline color='red' style={{ height: "60px", width: "60px", fontWeight: "10px" }} />
                        <h5>Error!</h5>
                        <p className="mb-3">{gstErrorMsg}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => setGstErrorMsg(null)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {showDscPasswordModal && <Modal keyboard={false} backdrop="static" show={showDscPasswordModal} centered >
                    <Modal.Header>
                        <Modal.Title><div>
                            Enter DSC Password
                            <div style={{ fontSize: "14px", color: "gray" }}>DSC Password</div>
                        </div></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column justify-content-center align-items-center gap-3 w-60">
                        <div className="login-input" style={{ border: `${dscPassword?.length === 0 ? "1px solid red" : "1px solid lightgray"}`, marginTop: "0px" }}>
                            <RiLockPasswordLine />
                            <input
                                type="password"
                                placeholder="Enter DSC Password"
                                value={dscPassword}
                                // onFocus={() => setDscPassword("")}
                                onChange={(e) => setDscPassword(e.target.value)}
                                style={{ width: "100%" }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="footer">
                        <Button variant="secondary" className="secondary-left" onClick={() => {
                            setShowDscPasswordModal(false)
                            setDscPassword('')
                        }}>Close</Button>
                        <Button variant="secondary" className="secondary" onClick={() => {
                            uploadDsc(fileIndex)
                            setShowDscPasswordModal(false)
                            setDscPassword('')
                        }}>Upload</Button>
                    </Modal.Footer>
                </Modal>}
            </div >
        </>
    )
}
